import { render, staticRenderFns } from "./PopupStackView.vue?vue&type=template&id=56924c56&scoped=true&"
import script from "./PopupStackView.vue?vue&type=script&lang=js&"
export * from "./PopupStackView.vue?vue&type=script&lang=js&"
import style0 from "./PopupStackView.vue?vue&type=style&index=0&id=56924c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56924c56",
  null
  
)

export default component.exports